import * as React from 'react'

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="18" height="18" rx="4" fill="#FFECCF" stroke="#FFDBA4" strokeWidth="2" />
    <path d="M10 5L10 11" stroke="#CF8922" strokeWidth="2" />
    <path d="M10 13V15" stroke="#CF8922" strokeWidth="2" />
  </svg>
)
